import request from '@/utils/request';

// 列表
export function ApiHouseholdList(query) {
  return request({
    url: '/lock/gmwebapi/householdList',
    method: 'get',
    params: query,
  });
}

// 详情
export function ApiHouseholdDetail(query) {
  return request({
    url: '/lock/gmwebapi/householdDetails/' + query,
    method: 'get',
  });
}

// 新增
export function ApiHouseholdAdd(query) {
  return request({
    url: '/lock/gmwebapi/addHousehold',
    method: 'post',
    data: query,
  });
}

// 导入
export function ApiHouseholdImport() {
  return process.env.VUE_APP_BASE_API + '/lock/gmwebapi/importHousehold';
}

// 编辑
export function ApiHouseholdEdit(query) {
  return request({
    url: '/lock/gmwebapi/updateHousehold',
    method: 'put',
    data: query,
  });
}

// 删除
export function ApiHouseholdDelete(query) {
  return request({
    url: '/lock/gmwebapi/deleteHousehold/' + query,
    method: 'delete',
  });
}

// 解绑
export function ApiHouseholdUnbind(query) {
  return request({
    url: '/lock/gmwebapi/deviceUnbind',
    method: 'put',
    data: query,
  });
}